import React, { useContext, createContext } from "react";
import useSWR from "swr";
import { useUserContext } from './UserContext';
import axiosInstance from '../utils/axiosInstance';

// Create a context for items
const ItemContext = createContext(null);

// Fetcher function to get data from the server
const fetcher = async (args) => {
  // Destructure the args array to get URL and organization_id
  const [url, organization_id] = args;
  const response = await axiosInstance.get(url, {
    params: {
      organization_id,
    },
  });
  return response.data;
};

// Provider to wrap components and make data available
export const ItemProvider = ({ children }) => {
  const { user } = useUserContext();
  const organization_id = user ? user.organization_id : null;

  const { data: orgItems, error ,mutate} = useSWR(
    organization_id ? [`/items`, organization_id] : null,
    fetcher,
    {
      dedupingInterval: 10000,
      revalidateOnFocus: false,
    }
  );

  if (error) {
    console.error("An error occurred:", error);
  }

  return (
    <ItemContext.Provider value={{ orgItems, error,mutate }}>
      {children}
    </ItemContext.Provider>
  );
};

// Hook to access item data
export const useItems = () => {
  const context = useContext(ItemContext);
  if (context === null) {
    throw new Error("useItems must be used within an ItemProvider");
  }
  return context;
};
